<div class="dialog-shell">
  <section class="panel panel--form">
    <header>
      <h2>{{ formMeta.formName }}</h2>
      <p>{{ formMeta.formDescription }}</p>
    </header>
    @if (!optionsLoaded) {
      <div class="panel__loading">
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
        <p>Loading form controls…</p>
      </div>
    } @else {
      <app-dynamic-forms-v2
        class="form-panel"
        [formFields]="formFields"
        [formMetaData]="formMeta"
        [prepopulatedData]="dynamicFormPreset"
        [resetOnSubmit]="false"
        (onEveryChange)="handleFormChange($event)"
        (formSubmitted)="handleFormSubmit($event)">
      </app-dynamic-forms-v2>
    }
  </section>

  <mat-divider vertical></mat-divider>

  <section class="panel panel--review">
    <header>
      <h2>Resource data review</h2>
      <p>Generate a preview by submitting the form, then make final adjustments before saving.</p>
    </header>
    @if (reviewResource && reviewFormData) {
      <app-resource-data-review
        [resource]="reviewResource"
        [formFields]="formFields"
        [submittedData]="reviewFormData"
        [mapResourceToSubmittedData]="mapResourceToSubmittedData"
        [applySubmittedDataToResource]="applySubmittedDataToResource"
        (fieldEdited)="handleFieldEdited($event)"
        (resourceUpdated)="handleResourceUpdated($event)">
      </app-resource-data-review>
    } @else {
      <div class="panel__placeholder">
        <mat-icon fontIcon="rate_review"></mat-icon>
        <p>Complete the form and click <strong>{{ formMeta.submitText }}</strong> to see the FHIR preview.</p>
      </div>
    }
  </section>
</div>

<mat-divider></mat-divider>

<div class="dialog-actions">
  <button mat-button type="button" (click)="cancel()" [disabled]="isSaving">Cancel</button>
  <button mat-flat-button color="primary" type="button" (click)="save()" [disabled]="isSaving || !reviewFormData">
    @if (isSaving) {
      <mat-progress-spinner diameter="18" mode="indeterminate"></mat-progress-spinner>
      <span>Saving…</span>
    } @else {
      <span>{{ isEditMode ? 'Update Service' : 'Save Service' }}</span>
    }
  </button>
</div>
